module.exports = __webpack_public_path__ + "static/media/github-square.358847e2.svg";